/**
 * Toast notification hook
 * Provides user feedback for actions (success, info, warning)
 * Now uses centralized ToastContext for global state management
 */

import { useToastContext, Toast, ToastAction, ShowToastOptions } from '../contexts/ToastContext';

export type { Toast, ToastAction, ShowToastOptions };

interface UseToastReturn {
  toasts: Toast[];
  showToast: (message: string, typeOrOptions?: Toast['type'] | ShowToastOptions, duration?: number) => void;
  removeToast: (id: string) => void;
}

export const useToast = (): UseToastReturn => {
  return useToastContext();
};
